// Shared "install the wallet app" helper for the owner + staff enroll screens.
// Some customers — especially on older PH Android — don't have Google Wallet
// installed yet, so the enrollment QR has nowhere to land; iPhone users almost
// always have Apple Wallet pre-installed, but the App Store QR is offered too
// for the rare re-install / for completeness. Collapsed by default so it
// doesn't clutter the common case where the wallet app is already there.
//
// Lives in apps/web/src/shared because the owner and staff enroll pages both
// use it (previously duplicated verbatim in each). Reuses the existing
// `staff-enroll-wallet-*` / `owner-btn` / `stamp-hint` classes so it styles
// identically on both screens.

import { useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'

const GOOGLE_WALLET_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.walletnfcrel'
// Apple Wallet on the App Store (PH storefront). Apple Wallet is pre-installed
// on iPhones, so this is mainly for completeness / a deleted-app re-install.
const APPLE_WALLET_APP_URL = 'https://apps.apple.com/ph/app/apple-wallet/id1160481993'

export function WalletInstallNudge() {
  const [open, setOpen] = useState(false)
  return (
    <div className="staff-enroll-wallet-nudge">
      <button
        type="button"
        className="owner-btn owner-btn-sm"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {open ? 'Hide wallet install QR' : "Customer doesn't have a wallet app?"}
      </button>
      {open && (
        <div className="staff-enroll-wallet-qr">
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1.25rem',
              justifyContent: 'center',
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <QRCodeSVG
                value={GOOGLE_WALLET_PLAY_URL}
                size={150}
                level="M"
                includeMargin
              />
              <div className="stamp-hint">Google Wallet · Android</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <QRCodeSVG
                value={APPLE_WALLET_APP_URL}
                size={150}
                level="M"
                includeMargin
              />
              <div className="stamp-hint">Apple Wallet · iPhone</div>
            </div>
          </div>
          <p className="stamp-hint">
            Have the customer scan the one for their phone to install the wallet
            app, then scan the enrollment QR above.
          </p>
        </div>
      )}
    </div>
  )
}
